<template>
  <div class="about_left">
    <p class="title">控制面板</p>
    <ul>
      <router-link tag="li" :to="{name: 'overview'}">
        <span>信息汇总</span>
      </router-link>
      <router-link tag="li" :to="{name: 'authorisation'}">
        <span>授权信息</span>
      </router-link>
      <router-link tag="li" :to="{name: 'user'}">
        <span>用户管理</span>
      </router-link>
      <router-link tag="li" :to="{name: 'download'}">
        <span>下载历史</span>
      </router-link>
      <router-link tag="li" :to="{name: 'log'}">
        <span>使用记录</span>
      </router-link>
      <router-link tag="li" :to="{name: 'affiliation'}">
        <span>关联企业</span>
      </router-link>
    </ul>
  </div>
</template>
<script>
export default {
    name: 'sidebar',
    data() {
        return {}
    }
}
</script>
<style scoped>
.about_left .title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
}
.about_left ul {
    margin: 0;
    padding: 0;
    list-style: none;
}
.about_left li {
  cursor: pointer;
  transition: all 0.4s;
  -webkit-transition: all 0.4s;
  -moz-transition: all 0.4s;
}
.about_left li span {
  display: inline-block;
  padding-left: 10px;
  height: 20px;
  line-height: 20px;
  margin: 15px auto 10px;
}
.about_left li.router-link-active span {
  font-weight: 600;
  border-left: 3px solid #ff9f00;
}
</style>